module.exports = __webpack_public_path__ + "img/11158812000267.0b735f12.png";